module.exports = __webpack_public_path__ + "static/media/mastercardidentitycheck.8f6ba038.png";